import RESTClient from 'web-app/api/clients/rest-client-famly-app';

export const dismiss = () => RESTClient.postAuthenticatedObservable('v2/dismiss', {itemType: 'FAMLY_PAY_SETUP'});
